declare global {
  interface Window {
    dev: () => boolean;
    hasRemote: () => boolean;
    hasMode: (mode) => boolean;
    mode: string;
    savedStore: any;
    locationHistory: string;
    // USE_UPDATED_NAV: boolean;
    IS_CHAMELEON_MODULE: boolean;
    fonts: any;
    FontFace: any;
  }
  interface Document {
    fonts: any;
  }
}

if (!('IntersectionObserver' in window)) require('intersection-observer');

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import React, { Fragment as _ } from 'react';
import ReactDOM from 'react-dom';
import './setup';
import getStore from 'services/getStore';
import { Provider } from 'react-redux';
import Module from 'components/Module';
import 'services/scorm/scormService';
import { addFont } from 'services/fontService';
import 'styles/global';
import { Client } from '@chameleoncreator/creator-client';
import { ErrorBoundary } from 'components/errorHandler';
import BootScreen from 'components/lib/BootScreen';
import init from 'services/imagePreloader';
// import ImagePreloader from 'components/lib/ImagePreloader';
import { useEffect } from 'react';

import 'regenerator-runtime/runtime.js';

//
import 'assets/whoopsBrowserIncompatible.png';
import 'assets/Carousel_Placeholder.png';
import 'assets/clickNReveal_default.png';
import 'assets/Correct_loop.gif';
import 'assets/Incorrect_loop.gif';
import 'assets/Attempt.svg';
import 'assets/Incorrect_default.svg';
import 'assets/FlipCard_loop.gif';
import 'assets/Media_default.svg';
import 'assets/Media_loop.gif';
import 'assets/animations/placeholder.js';
import 'assets/MultiChoice_loop.gif';

// import {
//   Provider as GraphQlProvider,
//   createClient,
//   // useQuery,
//   // Query,
// } from 'urql';

// const client = createClient({
//   fetchOptions: { credentials: 'include' },
//   url: 'https://chameleon-development.herokuapp.com/graphql',
// });

// has to mirror index.tsx until. . .
// window.USE_UPDATED_NAV = true;
//parent.IS_CHAMELEON_MODULE = true;
window.dev = () => !!parent.IS_CHAMELEON_EDITOR;

// disable all react-beautiful-dnd development warnings
window['__react-beautiful-dnd-disable-dev-warnings'] = true;

const store = getStore();

try {
  const top = parent.top as any;

  if (top.chameleon) {
    window.hasRemote = () => !!top.chameleon.CHAMELEON_URL;
    window.client = new Client(top.chameleon.CHAMELEON_URL);
  }
} catch (err) {
  // console.warn(err);
}

const loadTheme = store.subscribe(() => {
  const {
    backgroundColor = '',
    fontFamily = '',
    fontFamilies = [],
  } = store.getState().theme;

  document.body.style.background = backgroundColor;

  if (!!fontFamilies.length) {
    fontFamilies.forEach(f => {
      addFont(f);
    });
  }

  // just wanting to smash this until it displays for sure
  if (fontFamily) {
    const checkFontFamilyDisplays = setInterval(() => {
      if (document.body.style.fontFamily === `"${fontFamily}"`)
        clearInterval(checkFontFamilyDisplays);
      document.body.style.fontFamily = fontFamily;
    }, 0);
  }

  loadTheme.unsubscribe && loadTheme.unsubscribe();
});

init(store.getState().blocks);

// const CallFunctionsFromWithinComponentTree = ({
//   functions,
// }: {
//   functions: Function[];
// }) => {
//   useEffect(() => {
//     functions.forEach(fN => fN());
//   }, []);

//   return null;
// };

{
  /* <CallFunctionsFromWithinComponentTree
functions={[() => init(store.getState().blocks)]}
/> */
}

ReactDOM.render(
  <_>
    <ErrorBoundary>
      {/* <GraphQlProvider value={client}> */}
      {/* <ImagePreloader /> */}
      <Provider store={store}>
        <Module />
      </Provider>
      {/* </GraphQlProvider> */}
    </ErrorBoundary>
    {/* {!window.dev() && <BootScreen theme={store.getState().theme} />} */}
  </_>,
  document.querySelector('#root')
);

// if (module && module['hot']) module['hot'].accept();
